import { authenticationTypes } from "@/types";

export const state: authenticationTypes = {
  idToken: null,
  userId: null,
  isLogged: false
};
